export default __webpack_public_path__ + "fr/static/media/search-icon.882aa18e.svg";